class Declaracao {
  constructor() {

  }
}

export default Declaracao